import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { ErrorPage, HomePage, FilesPage, LogsPage } from "./pages";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import { logService } from "./services";

// Capture FE errors into localStorage so they can be inspected from the /logs
// page. Especially useful for debugging on mobile browsers with no devtools.
logService.initLogging();

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <HomePage />,
        errorElement: <ErrorPage />,
      },
      {
        path: "/files",
        element: <FilesPage />,
        errorElement: <ErrorPage />,
      },
      {
        path: "/auth-error",
        element: <ErrorPage />,
      },
      {
        path: "/logs",
        element: <LogsPage />,
        errorElement: <ErrorPage />,
      },
    ],
  },
]);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
